import React from 'react';
import { useTranslation } from "@/lib/i18n";
import { Palette } from 'lucide-react';
import { BASE_LASER_COLORS } from '@/constants/editor';

export default function ColorPalettePanel({
  currentColor,
  isSingleSelected,
  activeSelectedCount,
  onApplyColor,
  theme = 'dark',
}) {
  const { t } = useTranslation('editor');
  const isCustomColor = !BASE_LASER_COLORS.some(
    (c) => c.hex.toLowerCase() === currentColor.toLowerCase()
  );

  return (
    <div
      className={`border rounded-md p-2 flex flex-col gap-1.5 transition-all duration-300 ${
        theme === 'dark' ? 'bg-zinc-950/70 border-zinc-800' : 'bg-white border-slate-100 shadow-sm'
      } ${
        isSingleSelected ? 'opacity-100' : 'opacity-40 pointer-events-none'
      }`}
    >
      <div className="flex items-center justify-between">
        <span className={`text-[11px] font-semibold uppercase flex items-center gap-1 ${
          theme === 'dark' ? 'text-zinc-400' : 'text-slate-500'
        }`}>
          <Palette className="w-3.5 h-3.5 text-indigo-400" /> {t('colors.element_color')}
        </span>
        {!isSingleSelected && (
          <span className="text-[10px] text-neutral-500 italic">
            {activeSelectedCount > 1 ? t('transform.select_one_hint') : t('transform.nothing_selected_hint')}
          </span>
        )}
      </div>

      <div className="flex items-center gap-1.5 flex-wrap">
        <div
          className={`relative w-6 h-6 rounded border overflow-hidden cursor-pointer hover:scale-105 transition-transform ${
            isCustomColor
              ? 'ring-2 ring-indigo-400 border-white scale-105'
              : theme === 'dark' ? 'border-zinc-700' : 'border-slate-200'
          }`}
          title={t('colors.custom_color')}
        >
          <input
            type="color"
            value={currentColor}
            onChange={(e) => onApplyColor(e.target.value)}
            disabled={!isSingleSelected}
            className="absolute -top-2 -left-2 w-10 h-10 cursor-pointer border-0 p-0"
          />
        </div>

        <div className={`h-4 w-[1px] mx-0.5 ${theme === 'dark' ? 'bg-zinc-800' : 'bg-slate-100'}`} />

        {BASE_LASER_COLORS.map((c) => {
          const isActive = currentColor.toLowerCase() === c.hex.toLowerCase();

          return (
            <button
              key={c.name}
              type="button"
              title={c.name}
              disabled={!isSingleSelected}
              onClick={() => onApplyColor(c.hex)}
              className={`w-5 h-5 rounded-full transition-all cursor-pointer relative ${
                isActive
                  ? `ring-2 ring-indigo-400 ring-offset-2 border-2 border-white scale-110 z-10 ${
                      theme === 'dark' ? 'ring-offset-zinc-900' : 'ring-offset-white'
                    }`
                  : `border hover:scale-110 opacity-80 hover:opacity-100 ${
                      theme === 'dark' ? 'border-zinc-700/80' : 'border-slate-200'
                    }`
              }`}
              style={{ backgroundColor: c.hex }}
            />
          );
        })}
      </div>
    </div>
  );
}